import { ViewDensity } from "@common/types/views/views";
import { CounterpartyAddressesColumn } from "@common/types/views/counterpartyAddressesView";
import { CounterpartyAddress } from "@common/schemas/counterpartyAddress.schema";
import { ViewConfig } from "@lib/views";
import { CounterpartyAddressLinesCell } from "./cells/CounterpartyAddressLinesCell";
import { CounterpartyAddressActionsCell } from "./cells/CounterpartyBookActionsCell";
import { CounterpartyAddressPrimaryCell } from "./cells/CounterpartyBookPrimaryCell";
import { CounterpartyAddressTextCell } from "./cells/CounterpartyBookTextCell";

export const createCounterpartyAddressesViewConfig = (): ViewConfig<
    CounterpartyAddress,
    CounterpartyAddressesColumn,
    never
> => ({
    columns: {
        [CounterpartyAddressesColumn.ADDRESS]: {
            accessorKey: "street",
            name: "Address",
            header: "Address",
            immutable: true,
            cell: CounterpartyAddressLinesCell,
            minSize: 180,
        },
        [CounterpartyAddressesColumn.LABEL]: {
            accessorKey: "label",
            name: "Label",
            header: "Label",
            immutable: true,
            cell: CounterpartyAddressTextCell,
            minSize: 80,
            maxSize: 140,
        },
        [CounterpartyAddressesColumn.PRIMARY]: {
            accessorKey: "isPrimary",
            name: "Primary",
            header: "Primary",
            immutable: true,
            cell: CounterpartyAddressPrimaryCell,
            minSize: 80,
            maxSize: 100,
        },
        [CounterpartyAddressesColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            align: "right",
            immutable: true,
            hiddenFromSettings: true,
            cell: CounterpartyAddressActionsCell,
            minSize: 48,
            maxSize: 56,
        },
    },
    density: ViewDensity.SM,
});
